// extracted by mini-css-extract-plugin
export default {"Nav2wrapper":"content_Nav2wrapper__71Pk6","un":"content_un__yiYLl","selected":"content_selected__U-fGC"};